/**
 * Las cuentas de campo se autentican contra `<documento>@campo.treid.pe`. Nadie usa ese
 * buzon: es solo el identificador interno que Supabase necesita, porque admite un correo
 * por cuenta y los recursos de campo no tienen correo propio.
 *
 * Portado de `treid-campo/app/src/domain/loginIdentity.ts` a proposito, sin mejorarlo: si
 * las dos apps resuelven distinto el mismo documento, una deja entrar y la otra no, y el
 * usuario no tiene forma de entender por que.
 */
export const CAMPO_EMAIL_DOMAIN = 'campo.treid.pe';

export function documentoACorreo(entrada: string): string {
  const limpio = entrada.trim().toLowerCase();

  // Quien escribe un correo completo (el personal de oficina) entra con ese.
  if (limpio.includes('@')) return limpio;

  // ⚠️ Los ceros a la izquierda se quitan porque `approve-worker` crea la cuenta sin ellos.
  // Sin esta linea, un carne con cero adelante entra con un correo que no existe. Es el
  // fallo del §3.23 de la bitacora: se podia ENTRAR con el documento pero no ser ASIGNADO.
  const sinCeros = limpio.replace(/^0+/, '');
  return `${sinCeros}@${CAMPO_EMAIL_DOMAIN}`;
}
